import type { AccordionProps } from "@op/puck-types";
import { Print_Dc_Text_Toggle } from "@op/sf-op";

const Accordion = ({ heading, children }: AccordionProps) => {
  return (
    <Print_Dc_Text_Toggle headline={heading}>{children}</Print_Dc_Text_Toggle>
  );
};

export default Accordion;
